export default "__VITE_IMAGE_ASSET__8410f33c__";